var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userList"},[_c('div',{staticClass:"role"},[_vm._v("Disponivel - 2")]),_vm._v(" "),_c('UserRow',{attrs:{"nickName":"Ediberto Oliveira"}}),_vm._v(" "),_c('UserRow',{attrs:{"nickName":"MecBOT","isBot":""}}),_vm._v(" "),_c('div',{staticClass:"role"},[_vm._v("Indisponivel - 18")]),_vm._v(" "),_vm._l((20),function(user){return _c('UserRow',{key:user.id,attrs:{"nickName":"Fulano de tal"}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555e4cf5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User-List/index.vue
// module id = 97
// module chunks = 0